import type { WorldBuilderResult } from '@creanizer/types'

interface WorldUniqueFeaturesProps {
  uniqueFeatures?: WorldBuilderResult['uniqueFeatures']
}

export function WorldUniqueFeatures({ uniqueFeatures }: WorldUniqueFeaturesProps) {
  if (!uniqueFeatures) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        独自要素のデータがありません
      </div>
    )
  }
  
  return (
    <div className="space-y-4">
      {uniqueFeatures.signature && (
        <div className="p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg">
          <h3 className="font-semibold mb-2 flex items-center gap-2">
            <span className="text-purple-600">★</span>
            シグネチャー要素
          </h3>
          <p className="text-sm">{uniqueFeatures.signature}</p>
        </div>
      )}
      
      {uniqueFeatures.laws && uniqueFeatures.laws.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2 flex items-center gap-2">
            <span className="text-indigo-600">⚖</span>
            独自の法則・ルール
          </h4>
          <div className="space-y-2">
            {uniqueFeatures.laws.map((law, index) => (
              <div key={index} className="flex items-start gap-2 p-2 bg-indigo-50 rounded">
                <span className="text-indigo-600 mt-0.5">•</span>
                <span className="text-sm">{law}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {uniqueFeatures.paradoxes && uniqueFeatures.paradoxes.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2 flex items-center gap-2">
            <span className="text-orange-600">⚡</span>
            パラドックス・矛盾
          </h4>
          <div className="space-y-2">
            {uniqueFeatures.paradoxes.map((paradox, index) => (
              <div key={index} className="flex items-start gap-2 p-2 bg-orange-50 rounded">
                <span className="text-orange-600 mt-0.5">!</span>
                <span className="text-sm">{paradox}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {uniqueFeatures.mysteries && uniqueFeatures.mysteries.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2 flex items-center gap-2">
            <span className="text-purple-600">?</span>
            未解明の謎
          </h4>
          <div className="space-y-2">
            {uniqueFeatures.mysteries.map((mystery, index) => (
              <div key={index} className="flex items-start gap-2 p-2 bg-purple-50 rounded">
                <span className="text-purple-600 mt-0.5">◈</span>
                <span className="text-sm text-muted-foreground">{mystery}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {uniqueFeatures.innovations && uniqueFeatures.innovations.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2 flex items-center gap-2">
            <span className="text-green-600">💡</span>
            独自の発明・発見
          </h4>
          <div className="flex flex-wrap gap-2">
            {uniqueFeatures.innovations.map((innovation, index) => (
              <span
                key={index}
                className="px-3 py-1 text-sm bg-green-100 text-green-700 rounded-full"
              >
                {innovation}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}